import { createAsyncThunk } from "@reduxjs/toolkit";

import api from "api";
import { proceedThunk } from "./utils";

export const voicesListThunk = createAsyncThunk(
  "voice/list",
  proceedThunk(api.modelManager.voice.list)
);

export const privateVoicesCheckThunk = createAsyncThunk(
  "voice/privateCheck",
  proceedThunk(api.modelManager.voice.list)
);

export const setFavoriteVoiceThunk = createAsyncThunk(
  "voice/favorite",
  proceedThunk(api.modelManager.voice.favorite)
);

export const updateVoiceSettingsThunk = createAsyncThunk(
  "voice/settings/update",
  proceedThunk(api.modelManager.voice.updateSettings)
);

export const voicesInitialSearchListThunk = createAsyncThunk(
  "voice/search/initialList",
  proceedThunk(api.modelManager.voice.list)
);

export const searchVoicesThunk = createAsyncThunk(
  "voice/search",
  proceedThunk(api.modelManager.voice.search)
);

export const voicesByIdsThunk = createAsyncThunk(
  "voice/by-ids",
  proceedThunk(api.modelManager.voice.byIds)
);

export const accentInfosThunk = createAsyncThunk(
  "accent/infos",
  proceedThunk(api.modelManager.accent.infos)
);

export const demoSetsThunk = createAsyncThunk(
  "demoSets/list",
  proceedThunk(api.modelManager.demoSets)
);

export const getNarrationStyleTagsThunk = createAsyncThunk(
  "narrationStyleTags/list",
  proceedThunk(api.modelManager.getNarrationStyleTags)
);

export const getNarrationStyleTagGroupsThunk = createAsyncThunk(
  "narrationStyleTagGroups/list",
  proceedThunk(api.modelManager.getNarrationStyleTagGroups)
);
